const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_auth/sign-in/app.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { SignInAppSearchSchema } from '@apps/main/features/auth/pages/sign-in-app-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_auth/sign-in/app')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: SignInAppSearchSchema
});